module.exports = __webpack_public_path__ + "img/Anhänger_MzB.bb682d83.svg";